import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { TableColumn, TableRow } from 'react-md';
import cn from 'classnames';

import PsyActionsColumn from '../Contested/PsyActions';

export default injectIntl(class ContestedRow extends PureComponent {
    static propTypes = {
      intl: intlShape.isRequired,
      segment: PropTypes.object.isRequired,
      userAttributes: PropTypes.shape({
        isPsy: PropTypes.bool.isRequired,
      }),
      onSegmentClick: PropTypes.func.isRequired,
      selected: PropTypes.bool.isRequired,
      isLoading: PropTypes.bool,
      isAccepted: PropTypes.bool,
      isRejected: PropTypes.bool,
    };

    render() {
      const {
        segment,
        userAttributes,
        userAttributes: { isPsy },
        intl,
        onSegmentClick,
        selected,
        isLoading: isLoadingProps,
        isAccepted,
        isRejected,
        ...restOfProps
      } = this.props;

      return (
        <TableRow
          key={segment.segmentId}
          className={cn(
                'md-pointer--hover',
                segment.segmentState === 'ACCEPTED' ? 'noOverSpeed' : segment.overspeed,
            )}
          onClick={(e) => {
              if (!(typeof e.target.className !== 'undefined' && e.target.className === 'md-icon material-icons md-text--inherit') &&
              !(typeof e.target.type !== 'undefined' && e.target.type === 'checkbox')) {
                onSegmentClick(segment);
              }
            }}
          selected={selected}
          selectable={isPsy && !isLoadingProps && !isAccepted && !isRejected}
          {...restOfProps}
        >
          {isPsy && (isLoadingProps || isAccepted || isRejected) && <TableColumn />}
          <TableColumn >{Math.round(segment.avg)}km/h</TableColumn>
          <TableColumn >{segment.limit}km/h</TableColumn>
          <TableColumn>{intl.formatDate(segment.start, {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            })}
          </TableColumn>
          {isPsy &&
            <TableColumn>{segment.driverName}</TableColumn>
          }
          <TableColumn tooltipLabel={segment.formatted_address} >
            <div className="ellipsis">{segment.formatted_address}</div>
          </TableColumn>
          <TableColumn>{segment.GPSFixes}</TableColumn>
          <TableColumn>{intl.formatMessage({ id: `contestDialog.errorTypes.${segment.errorType.toLowerCase()}` })}</TableColumn>
          <TableColumn tooltipLabel={segment.errorReason} >
            <div className="ellipsis">{segment.errorReason}</div>
          </TableColumn>
          {isPsy &&
            <PsyActionsColumn segment={segment} isLoading={isLoadingProps} isAccepted={isAccepted} isRejected={isRejected} />
          }
        </TableRow>
      );
    }
});



// WEBPACK FOOTER //
// ./src/components/Contested/ContestedRow.js